import { gql } from '@apollo/client';

export const VALIDATE_CODE = gql`
  query ValidateCode($data: ValidateCodeInput!) {
    validateCode(data: $data) {
      status
      userId
    }
  }
`;
